let swRegistration = null;

function getServiceWorkerRegistration() {
    if (swRegistration) {
        return new Promise((resolve) => {resolve(swRegistration)});
    }
    if ('serviceWorker' in navigator) { //&& 'PushManager' in window
      console.log('Service Worker is supported');

      return navigator.serviceWorker.register('/service-worker.js')
      .then(function(swReg) {
        console.log('Service Worker is registered', swReg);

        swRegistration = swReg;
        return swRegistration;
      })
    } else {
      console.warn('Service worker is not supported');
      return new Promise((resolve, reject) => {reject('Service worker not supported')})
    }
}

export { getServiceWorkerRegistration }
